import React, { Component } from 'react';

import PiecesList from './PiecesList';

class Landing extends Component {
  render() {
    const { pieces } = this.props.config;
    return (
      <PiecesList pieces={pieces} />
    );
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/components/Landing.js